module.exports = __webpack_public_path__ + "img/c3.76cc4d39.jpg";